"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenuList;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactWindow = require("react-window");
var _Typography = _interopRequireDefault(require("../../Typography"));
var _NoOptionMessage = _interopRequireDefault(require("./NoOptionMessage"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint react/prop-types: 0 */

var itemHeight = 35;
function MenuList(props) {
  var listRef = (0, _react.useRef)(null);
  var children = props.children,
    getValue = props.getValue,
    isLoading = props.isLoading,
    options = props.options,
    selectProps = props.selectProps;
  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      noWrap: true,
      variant: "body1",
      className: selectProps.classes.virtualLoadingMessage
    }, "Loading ...");
  }
  var optCount = children.length || 0;
  if (!optCount) {
    return /*#__PURE__*/_react["default"].createElement(_NoOptionMessage["default"], props, selectProps.noOptionsMessage());
  }
  var _getValue = getValue(),
    _getValue2 = (0, _slicedToArray2["default"])(_getValue, 1),
    value = _getValue2[0];
  var currentIndex = options.indexOf(value);
  var initialOffset = currentIndex * itemHeight;
  var height = Math.min(260, itemHeight * Math.max(optCount, 1));
  if (listRef !== null && listRef !== void 0 && listRef.current) {
    if (currentIndex === -1) {
      listRef.current.scrollToItem(0);
    } else {
      listRef.current.scrollToItem(currentIndex);
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, (0, _extends2["default"])({
    ref: listRef,
    height: height,
    initialScrollOffset: initialOffset,
    itemCount: optCount,
    itemSize: itemHeight
  }, props), function (_ref) {
    var index = _ref.index,
      style = _ref.style;
    /*  Improves performance in react-select's row highlighting code
           highlighting changed to be CSS driven
           See issue here: https://github.com/JedWatson/react-select/issues/3128#issuecomment-521242192
       */
    delete children[index].props.innerProps.onMouseMove;
    delete children[index].props.innerProps.onMouseOver;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: style
    }, children[index]);
  });
}